import { api } from '../../services/api';
import {
  GET_DOCTOR_FAILURE, GET_DOCTOR_SUCCESS, SAVE_DOCTOR, SET_LOADING
} from '../reducers/types';

export const getDoctors = () => async (dispatch) => {
  try {
    dispatch({ type: SET_LOADING });
    const response = await api.get('/medicos');
    dispatch({ type: GET_DOCTOR_SUCCESS, payload: response.data.medicos });
  } catch (error) {
    dispatch({ type: GET_DOCTOR_FAILURE, payload: error });
  }
};

export const saveDoctor = (doctor) => async (dispatch) => {
  dispatch({ type: SAVE_DOCTOR, payload: doctor });
};
